module.exports = __webpack_public_path__ + "img/collection-memoireRingsBestseller.3a66694.jpg";